import { Rule } from 'antd/es/form'

// Name validation rules
export const nameValidationRules = {
  firstName: [
    {
      pattern: /^[A-Za-z\s\-']+$/,
      message:
        'Please enter a valid first name (letters, spaces, hyphens, and apostrophes only)',
    },
    {
      min: 2,
      message: 'First name must be at least 2 characters long',
    },
    {
      max: 50,
      message: 'First name cannot exceed 50 characters',
    },
  ] as Rule[],

  middleName: [
    {
      pattern: /^[A-Za-z\s\-']*$/,
      message:
        'Please enter a valid middle name (letters, spaces, hyphens, and apostrophes only)',
    },
    {
      max: 50,
      message: 'Middle name cannot exceed 50 characters',
    },
  ] as Rule[],

  lastName: [
    {
      pattern: /^[A-Za-z\s\-']+$/,
      message:
        'Please enter a valid last name (letters, spaces, hyphens, and apostrophes only)',
    },
    {
      min: 2,
      message: 'Last name must be at least 2 characters long',
    },
    {
      max: 50,
      message: 'Last name cannot exceed 50 characters',
    },
  ] as Rule[],
}

// Phone validation rules
export const phoneValidationRules = [
  {
    pattern: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    message: 'Please enter a valid USA phone number. Only numbers are allowed.',
  },
  {
    validator: (_: unknown, value: string) => {
      if (!value) return Promise.resolve()
      // Remove all non-digit characters for length check
      const digitsOnly = value.replace(/\D/g, '')
      if (digitsOnly.length !== 10) {
        return Promise.reject('Phone number must be 10 digits')
      }
      return Promise.resolve()
    },
  },
] as Rule[]

// City validation rules
export const cityValidationRules = [
  {
    pattern: /^[A-Za-z\s\-\.]+$/,
    message:
      'Please enter a valid city name (letters, spaces, hyphens, and periods only)',
  },
  {
    min: 2,
    message: 'City name must be at least 2 characters long',
  },
  {
    max: 50,
    message: 'City name cannot exceed 50 characters',
  },
] as Rule[]

// Zip code validation rules
export const zipValidationRules = [
  {
    pattern: /^\d{5}$/,
    message: 'Please enter a valid 5-digit USA zip code',
  },
] as Rule[]

// Address validation rules
export const addressValidationRules = [
  {
    pattern: /^[a-zA-Z0-9\s]+$/,
    message: 'Please enter a valid address (letters, numbers, and spaces only)',
  },
  {
    min: 5,
    message: 'Address must be at least 5 characters long',
  },
  {
    max: 100,
    message: 'Address cannot exceed 100 characters',
  },
] as Rule[]
